import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { CategoryView } from 'ish-core/models/category-view/category-view.model';
import { ProductListingView } from 'ish-core/models/product-listing/product-listing.model';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';

@Component({
  selector: 'ish-category-categories',
  templateUrl: './category-categories.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryCategoriesComponent implements OnInit, OnChanges, OnDestroy {
  @Input() category: CategoryView;
  @Input() deviceType: DeviceType;

  productListingView$: Observable<ProductListingView>;
  private destroy$ = new Subject<void>();

  constructor(private shoppingFacade: ShoppingFacade) {}

  isCollapsed = false;

  ngOnInit() {
    this.isCollapsed = this.deviceType === 'mobile';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!SSR) {
      window.scroll(0, 0);
    }

    this.isCollapsed = this.deviceType === 'mobile';

    const categoryId = changes.category.currentValue.uniqueId;
    this.productListingView$ = this.shoppingFacade
      .productListingView$({ type: 'category', value: categoryId })
      .pipe(takeUntil(this.destroy$));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggle() {
    this.isCollapsed = !this.isCollapsed;
    if (!SSR) {
      window.scroll(0, 0);
    }
  }
}
